import FacebookPixel from '@/analytics/facebook/FacebookPixel'

export default function init(app) {
  app.analytics.fbPixel = new FacebookPixel(app)
  app.analytics.fbPixel
    .install(app.$store.getters['settings/facebookPixel'].id)
    .then(() => console.log('Facebook Pixel has been installed.'))
    .catch(err => console.error('Unable to install Facebook Pixel.', err))
}
